<template>
<!-- 商品選択 -->
    <b-modal v-model="showFlg"
        size="lg"
        :hide-footer="true"
        header-bg-variant="light"
        :title="$t('cc212.labels.addressSelection')"
        @hide ="handleCancel"
        no-close-on-backdrop
        >
        <b-container fluid>
            <div class="row d-flex justify-content-center cc212">
                <div class="col-md-2"></div>
                   <div class="col-md-8 col-sm-12 border rounded">
                       <div class="row d-flex justify-content-center">
                           <div class="col-md-12 col-sm-12 = pt-2 pr-2 pl-2 pb-2 border-bottom" >
                            <!-- 候補の住所が複数あります。 -->
                            <p>{{$t("cc212.labels.thereAreMultiple")}}</p>
                            
                            <!-- 住所を選択し、選択するボタンを押してください。 -->
                            <p>{{$t("cc212.labels.selectAndPress")}}</p>
                           </div>
                           <div class="col-md-12 col-sm-12 mt-2 border-bottom">
                               <select id="_addr" v-model="addrSetValue" class="form-control form-control-sm mb-2">
                                    <option v-for="(addr,index) in listAddr" :KEY="index" :value="addr">
                                        {{addr.ALL_ADDR}}
                                    </option>
                                </select>
                           </div>
                           <div class="col-md-12 col-sm-12 text-center pt-2 pb-2" style="background-color: #CCFFCC">
                            <!-- 選択する -->
                                <b-btn size="sm" variant="success" @click="setValue">
                                    <!-- 閉じる -->
                                    {{$t('cc212.buttons.select')}}
                                </b-btn>
                           </div>
                       </div>
                    </div>
                    <div class="col-md-2"></div>
            </div>
            <div class="row border-top mt-2"></div>

            <div class="row d-flex justify-content-center mt-3">
                <template class="col-sm-12 text-center">
                <b-btn size="sm" class="w-4 text-center" variant="secondary" @click="showFlg = false">
                    <!-- 閉じる -->
                    {{$t('common.buttons.close')}}
                </b-btn>
            </template>
            </div>
            </b-container>
    </b-modal>
</template>

<script>
/* 
* Import libs and componnents
*/
import common from "assets/js/common";
import axios from "assets/js/request";

export default {
    /* 
    * Name of component
    */
    name: "CC212InputPostal",
    /* 
    * Declare components
    */
    components: {
        
    },/* 
    * Declare variable and set default value
    */
    props:['propTdkZip1', 'propTdkZip2', 'propIdx'],
    data() {
        return {
            showFlg: true,
            tdkZip1:this.propTdkZip1,
            tdkZip2:this.propTdkZip2,
            idx:this.propIdx,
            addrSetValue:"",
            kenCd:"",
            listAddr:{}
        }
    },/* 
    * Initialize
    */
    mounted(){
        var _this = this;
        var request = {
            tdkZip1:_this.tdkZip1,
            tdkZip2:_this.tdkZip2
        }
        axios.post(_this.$UrlConstants.POPUP +_this.$UrlConstants.CC212 + _this.$UrlConstants.DO_SEARCH, request).then(function(response) {
            _this.listAddr = response.data.list;
            var addr = response.data.list[0];
            _this.addrSetValue = addr;
            _this.kenCd = response.data.kenCd;
        }).catch(function(error) {
            common.errorAPI(error);
        });
    },
    methods:{
        setValue:function(){
            var  _this = this;
            var addr = _this.addrSetValue;
            var data = {
                addr:addr,
                kenCd:_this.kenCd,
                idx:_this.idx
            }
            this.$emit("set-addr-value", data);
            this.showFlg = false;
        },
        /**
         *  Exec close modal
         * @param {Any} evt, event close
         */
        handleCancel(evt){
            evt.preventDefault();
            this.showFlg = false;
        }
    },
    watch: {
        /*
        *  event close modal
        */
       // eslint-disable-next-line
        showFlg(newVal, oldVal) {
            this.$emit('modal-close', 'cc212');
        }
    },

}
</script>